const LOG_CONFIGURATIONS_URI = '/log-configurations';
const LOG_CONFIGURATIONS_RESOURCE_TYPE = 'application/vnd.iris.threads.log-configuration+json';
const THREADS_APPLICATION_IDENTITY = (domain) => `postmaster@threads.${domain}`;
export class LogConfigurationsService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async getLogConfigurations() {
        const logConfigurations = await this.MessagingHubService.processCommand({
            method: 'get',
            to: THREADS_APPLICATION_IDENTITY(this.MESSAGINGHUBDOMAIN),
            uri: LOG_CONFIGURATIONS_URI,
        });
        return logConfigurations.resource;
    }
    async updateLogConfiguration(logConfiguration) {
        return this.MessagingHubService.processCommand({
            method: 'set',
            to: THREADS_APPLICATION_IDENTITY(this.MESSAGINGHUBDOMAIN),
            uri: LOG_CONFIGURATIONS_URI,
            type: LOG_CONFIGURATIONS_RESOURCE_TYPE,
            resource: logConfiguration,
        });
    }
}
LogConfigurationsService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
